import Vue from 'vue'
import Router from 'vue-router'
import { getToken } from '../utils/auth'

import AdminLayout from '../layout/AdminLayout.vue'
import LoginView from '../views/Login.vue'
import UserListView from '../views/users/UserList.vue'
import ProductListView from '../views/products/ProductList.vue'
import QualificationListView from '../views/qualifications/QualificationList.vue'
import BannerListView from '../views/banners/BannerList.vue'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/login',
      name: 'login',
      component: LoginView,
      meta: { public: true }
    },
    {
      path: '/',
      component: AdminLayout,
      redirect: '/users',
      children: [
        {
          path: '/users',
          name: 'users',
          component: UserListView,
          meta: { title: '用户管理' }
        },
        {
          path: '/products',
          name: 'products',
          component: ProductListView,
          meta: { title: '商品管理' }
        },
        {
          path: '/qualifications',
          name: 'qualifications',
          component: QualificationListView,
          meta: { title: '资质管理' }
        },
        {
          path: '/banners',
          name: 'banners',
          component: BannerListView,
          meta: { title: '轮播管理' }
        }
      ]
    },
    {
      path: '*',
      redirect: '/users'
    }
  ]
})

router.beforeEach((to, from, next) => {
  const token = getToken()
  if (to.meta && to.meta.public) {
    if (token) {
      next('/users')
      return
    }
    next()
    return
  }
  if (!token) {
    next('/login')
    return
  }
  next()
})

export default router
